module.exports = __webpack_public_path__ + "img/leagues.a7f355d9.svg";